/* EasyLockdown custom */
// document.addEventListener('easylockdown_filters_inited', function(e){
//   easylockdown.jq('.new-arrivals-product .products-grid').each(function(i, el){
//     if( easylockdown.jq.trim(el.innerText) == '' ) { easylockdown.jq(el).closest('.new-arrivals-product').remove() }
//   });
// });

jQuery(document).ajaxComplete(function( event, request, settings ) {
  if( typeof easylockdown === 'object' && easylockdown.jq('.easylockdown-item-selector,.easylockdown-collection-item-selector').length ) {
    easylockdown.initFilters();
    easylockdown.hideAllLinks();
  }
});
/* EasyLockdown custom */